import { formatISO } from 'date-fns'

export const getAvailability = (day, dolphinReservations) => {
  const formattedDay = formatISO(day, { representation: 'date' })
  const noAvailability = { date: formattedDay, times: [] } // default value

  if (dolphinReservations && dolphinReservations.length > 0) {
    const foundAvailability = dolphinReservations.find(reservation => {
      return reservation.date == formattedDay
    })
    if (foundAvailability) {
      return foundAvailability
    } else {
      return noAvailability
    }
  }
  return noAvailability
}
